export default function registerThemeStore(Alpine) {
  const THEMES = ["light", "dark", "system"];

  Alpine.store("theme", {
    mode: "light",

    init() {
      const stored = localStorage.getItem("theme");

      this.mode = THEMES.includes(stored) ? stored : "light";

      this.apply();
    },

    set(mode) {
      const normalized = typeof mode === "string" ? mode.toLowerCase() : "";

      const finalMode = THEMES.includes(normalized) ? normalized : "light";

      this.mode = finalMode;

      localStorage.setItem("theme", finalMode);

      this.apply();
    },

    isDark() {
      if (this.mode === "dark") return true;

      if (this.mode === "light") return false;

      return window.matchMedia("(prefers-color-scheme: dark)").matches;
    },

    apply() {
      document.documentElement.classList.toggle("dark", this.isDark());
    },
  });
}
